const STORAGE_KEY = "user_brand_profile";

export const getBrandProfile = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveBrandProfile = (data) => {
  try {
    const existing = getBrandProfile() || {};
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...existing, ...data }));
  } catch {}
};

export const DEFAULT_BRAND_COLORS = {
  canvas: "#FAFAFA",
  structure: "#0D0D0D",
  accent: "#04EA77",
};